import { PageOverviewBanner } from '@/components';

import { ContentTypeName } from '@/constants';
import { capitalize } from '@/utils';

import { LeadGenBannerVariant } from '@/interfaces';
import SectionListRenderer from '../SectionListRenderer';

interface IHomepageRendererProps {
  // biome-ignore lint/suspicious/noExplicitAny: Contentful section list has dynamic shape
  sectionList?: any[];
}

const HomepageRenderer: React.FC<IHomepageRendererProps> = ({ sectionList = [] }) => {
  const foundPageOverviewBanner = sectionList.find(
    // biome-ignore lint/suspicious/noExplicitAny: Contentful section has dynamic shape
    (section: any) => capitalize(section.__typename) === ContentTypeName.PageOverviewBanner,
  );

  // biome-ignore lint/suspicious/noExplicitAny: Contentful section has dynamic shape
  const filteredSectionList = sectionList.reduce((filtered, section: any) => {
    if ([foundPageOverviewBanner].includes(section)) {
      return filtered;
    }
    if (capitalize(section.__typename) === ContentTypeName.LeadGenBanner) {
      section.variant = LeadGenBannerVariant.FULL_WIDTH;
    }
    // biome-ignore lint/performance/noAccumulatingSpread: list is small (bounded by CMS entries)
    return [...filtered, section];
  }, []);

  return (
    <>
      {foundPageOverviewBanner && <PageOverviewBanner priority {...foundPageOverviewBanner} />}
      <SectionListRenderer sectionList={filteredSectionList} hideSpacingBetweenSections />
    </>
  );
};

export default HomepageRenderer;
